function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-id-fail_svg__cls-3,.icon-id-fail_svg__cls-4{fill:none;stroke:#3fa9f5;stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.icon-id-fail_svg__cls-4{fill:#3fa9f5}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon-id-fail_svg__Layer_3",
  "data-name": "Layer 3"
}, /*#__PURE__*/React.createElement("rect", {
  x: 5.1,
  y: 6.08,
  width: 60.02,
  height: 45.24,
  rx: 6.23,
  strokeMiterlimit: 10,
  stroke: "#cccbcb",
  strokeWidth: 0.5,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 14.71,
  y: 15.62,
  width: 39.1,
  height: 26.67,
  rx: 5,
  stroke: "#3fa9f5",
  strokeWidth: 1.5,
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-id-fail_svg__cls-3",
  d: "M35.83 22.36h12.15M35.83 27.25h12.15M35.83 32.13h8.2"
}), /*#__PURE__*/React.createElement("circle", {
  className: "icon-id-fail_svg__cls-4",
  cx: 26.22,
  cy: 24.82,
  r: 3.65
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-id-fail_svg__cls-4",
  d: "M24.18 28.48c-2.86.41-3.93 6.41-3.84 7.25s5.88 1 5.88 1v-8.25zM28.27 28.48c2.86.41 3.93 6.41 3.84 7.25s-5.89 1-5.89 1v-8.25z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50.44,
  cy: 40.2,
  r: 7.84,
  fill: "#fbb040"
}), /*#__PURE__*/React.createElement("text", {
  transform: "translate(48.57 44.45)",
  fontSize: 12,
  fontFamily: "Arial-BoldMT,Arial",
  fontWeight: 700,
  fill: "#fff"
}, "!"));

function SvgIconIdFail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69.69 56.69"
  }, props), _ref, _ref2);
}

export default SvgIconIdFail;